<template>
  <div>
    <a-form-item>
      <a-cascader
        v-decorator="[
          'userid',
          {rules: [{ required: true, message: handoverPlace }], initialValue: val}
        ]"
        class="p-select"
        :field-names="{ label: 'name', value: 'id', children: 'children' }"
        :options="selectList"
        :placeholder="title"
        @change="onChange"
      />
    </a-form-item>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    val: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: Number,
      default: 0
    },
    form: {
      type: Object,
      default () {
        return {}
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('quit', ['selectList', 'quitName']),
    datas () {
      const { selectList } = this
      this.loopData(selectList)
      return selectList
    },
    handoverPlace () {
      return this.$t('message["868"]')
    }

  },
  watch: {
    type (val) {
      if (val) {
        this.form.setFieldsValue({ userid: [] })
      }
    },
    isShow (val) {
      if (val) {
        this.form.setFieldsValue({ userid: [] })
      }
    }
  },
  methods: {
    onChange (val, selectedOptions) {
      let obj = {}
      selectedOptions.forEach(item => {
        obj[item.keyname] = item.id
      })
      this.$emit('changeVal', obj)
    },
    loopData (arr) {
      const userid = this.quitName.userid
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === userid && (arr[i].keyname === 'userid')) {
          arr.splice(i, 1)
          return false
        }
        if (arr[i].children && arr[i].children.length > 0) {
          this.loopData(arr[i].children)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .p-select::v-deep {
    .ant-cascader-picker-clear {
    display: none;
  }
  }
</style>
